https: //api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
    ( function () {
        'use strict';
        jQuery.extend( true, e4.settings, {
            intersectionObserver: {
                options: {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0
                }
            },
            debounceDelay: {
                input: 250,
                resize: 500
            },
            ecom: {
                lazyload: {
                    buttonShowInterval: 4, // 0 = once, 1 = every page, 2, 3, 4, n = n time
                    autoLoadCount: 100, // if total product count is less than this - no load more button
                    observerOptions: {
                        root: null, // null = viewport
                        rootMargin: '50% 0px 50% 0px', // px or pct only
                        threshold: 0
                    }
                },
                filters: {
                    cleanUrl: true
                }
            }
        } );
    }() );
